export default "__VITE_ASSET__Dn73rgWq__"